module.exports = __webpack_public_path__ + "static/media/fb.af84d119.png";